import { render, staticRenderFns } from "./ProjectsListItem.vue?vue&type=template&id=8e2b5152&"
import script from "./ProjectsListItem.vue?vue&type=script&lang=js&"
export * from "./ProjectsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports